import React from 'react';
import { Link } from 'react-router-dom';
import { help } from '../../../utils/images';

function Help() {
	return (
		<>
			<div className="help-container">
				<div className="help-title">Vous avez besoin d'aide ?</div>
				<div className="container-img-title">
					<img alt="help icon" className="help-img" src={help}></img>
					<div>
						<div className="help-detail">
							Si vous avez des questions concernant notre service ou
							l'utilisation de notre plateforme; notre équipe de support client
							est disponible pour répondre à vos questions.
						</div>
						<Link to={'/'} className="help-link">
							Demande d'aide
						</Link>
					</div>
				</div>
			</div>
		</>
	);
}

export default Help;
